import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import axios from "../axios";
import { ToastContainer, toast } from "react-toastify";
import UserListItem from "../co-components/UserListItem";
import Spinner from "react-bootstrap/Spinner";
import UserSelectedItem from "../co-components/UserSelectedItem";

const UpdateGroupModal = ({
  //All these are props
  userInfo,
  updateGroupModal,
  setUpdateGroupModal,
  openChat,
  setOpenChat,
  getChatsAgain,
  setGetChatsAgain,
  fetchMessages,
}) => {
  // console.log("props", props);

  // const [userInfo, setUserInfo] = useState(props.userInfo);
  const [groupChatName, setGroupChatName] = useState(openChat.chatName);
  // const [search, setSearch] = useState();
  const [searchResult, setSearchResult] = useState([]);
  const [loading, setLoading] = useState();
  const [groupRenameLoading, setgroupRenameLoading] = useState(false);
  // const [selectedUsers, setSelectedUsers] = useState([]);
  // const [chats, setChats] = useState(props.chats);

  const [windowInnerwidth, setWindowInnerWidth] = useState(0);
  useEffect(() => {
    function handleResize() {
      // console.log("window.innerWidth",window.innerWidth);
      setWindowInnerWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setWindowInnerWidth]);

  const searchUser = async (value) => {
    if (!value) {
      toast.error("Please enter something to search user", {
        // position: "bottom-center",
        toastId: 18,
      });
      return;
    }
    try {
      setLoading(true);
      const token = userInfo.token;
      await axios
        .get(`/user?search=${value}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setSearchResult(res.data);
          // console.log("resss", res.data);
          // if (res.data.length < 1) { }
        });
      setLoading(false);
      // setSearch("");
    } catch (error) {
      console.log("Error Occured", error);
    }
  };
  const renameGroup = async () => {
    // console.log("groupChatName", groupChatName);

    if (!groupChatName) {
      toast.error("Please enter a group name", {
        // position: "bottom-center",
        toastId: 21,
      });
      return;
    }
    // if (groupChatName === openChat.chatName) {
    //   toast.error("Please enter new group name", {
    // position: "bottom-center",
    //     toastId: 21,
    //   });
    //   return;
    // }
    try {
      setgroupRenameLoading(true);
      const token = userInfo.token;
      const body = {
        chatId: openChat._id,
        chatName: groupChatName,
      };
      await axios
        .put("/chat/group/rename", body, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setOpenChat(res.data);
          setGetChatsAgain(res.data);
        });
      setgroupRenameLoading(false);
    } catch (error) {
      console.log("error while renaming group", error);
    }
  };
  const addGroupUser = async (addThisUser) => {
    // console.log("clickeduser", addThisUser);

    if (openChat.users.find((u) => u._id === addThisUser._id)) {
      toast.error("This User already exists", {
        // position: "bottom-center",
        toastId: 23,
      });
      return;
    }
    if (openChat.groupAdmin._id !== userInfo._id) {
      toast.error("You are not admin of this group", {
        // position: "bottom-center",
        toastId: 22,
      });
      return;
    }
    try {
      setLoading(true);
      const token = userInfo.token;
      const body = {
        chatId: openChat._id,
        userId: addThisUser._id,
      };
      await axios
        .put("/chat/group/add", body, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setOpenChat(res.data);
          setGetChatsAgain(res.data);
        });
      setLoading(false);
    } catch (error) {
      console.log("error while adding user in group", error);
    }
    // setSelectedUsers([...selectedUsers, addThisUser]);
  };
  const removeGroupUser = async (removeThisUser) => {
    if (openChat.groupAdmin._id !== userInfo._id) {
      toast.error("Only admmin can remove any user", {
        // position: "bottom-center",
        toastId: 23,
      });
      return;
    }
    if (removeThisUser._id === userInfo._id) {
      toast.error("Click leave group button to leave this group", {
        // position: "bottom-center",
        toastId: 24,
      });
      return;
    }
    try {
      setLoading(true);
      const token = userInfo.token;
      const body = {
        chatId: openChat._id,
        userId: removeThisUser._id,
      };
      await axios
        .put("/chat/group/remove", body, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          // removeThisUser._id === userInfo._id
          //   ? setOpenChat()
          //   :
          setOpenChat(res.data);

          // setGetChatsAgain(res.data);
          setGetChatsAgain(!getChatsAgain);
          fetchMessages();
        });
      setLoading(false);
    } catch (error) {
      console.log("error while removing user in group", error);
    }
  };
  const leaveGroup = async (user) => {
    // console.log("user", user.target);
    try {
      setLoading(true);
      const token = userInfo.token;
      const body = {
        chatId: openChat._id,
        userId: userInfo._id,
      };
      await axios
        .put("/chat/group/remove", body, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          // removeThisUser._id === userInfo._id
          // ?
          setOpenChat();
          // : setOpenChat(res.data);
          toast.success("Group leaved successfully", {
            // position: "bottom-center",
            toastId: 23,
          });
          // setGetChatsAgain(res.data);
          setGetChatsAgain(!getChatsAgain);
        });
      setLoading(false);
    } catch (error) {
      console.log("error while removing user in group", error);
    }
  };
  return (
    <div>
      <Modal
        show={updateGroupModal}
        // onHide={groupModalClose}
        onHide={() => setUpdateGroupModal(false)}
        centered
        // size="sm"
      >
        <Modal.Header
          closeButton
          className="modal-header border-0"
          // style={{ padding: "20px 20px 0px 0px" }}
          style={{
            fontSize: "25px",
            textAlign: "center",
            fontFamily: "Work sans",
            fontWeight: "700",
          }}
        >
          Update Group Chat
        </Modal.Header>
        <Modal.Body
          style={{
            justifyContent: "center",
            // display: "flex",
            textAlign: "center",
            padding: "10px",
          }}
        >
          <div>
            <div
              style={{
                display: "flex",
                marginBottom: "15px",
              }}
            >
              <input
                value={groupChatName}
                placeholder="Group Name"
                className="form-control"
                style={
                  {
                    // width: "400px",
                    //  marginBottom: "15px"
                  }
                }
                onChange={(e) => setGroupChatName(e.target.value)}
              />
              <Button
                style={{
                  // display: "flex",
                  background: "#48b84d",
                  border: "none",
                  marginLeft: "7px",
                  // "&:focus": { outline: "none", boxShadow: "none" },
                }}
                onClick={renameGroup}
              >
                {groupRenameLoading ? (
                  <div
                    style={{
                      fontSize: "10px",
                      marginRight: "15px",
                      marginLeft: "15px",
                    }}
                  >
                    <Spinner
                      animation="border"
                      variant="light"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </div>
                ) : (
                  <span
                    style={{
                      fontSize: "15px",
                    }}
                  >
                    Update
                  </span>
                )}
              </Button>
            </div>
            <div
              style={{
                marginTop: "3px",
                //  display: "flex"
              }}
            >
              {openChat.users.map((user) => {
                return (
                  <UserSelectedItem
                    key={user._id}
                    userInfo={userInfo}
                    user={user}
                    selectedUserDelete={() => removeGroupUser(user)}
                  />
                );
              })}
            </div>
            <input
              placeholder="Add users e.g:  Nadeem, Mansha, Hamza"
              className="form-control"
              onChange={(e) => searchUser(e.target.value)}
            />{" "}
            {/* -------------Users List----------- */}
            {loading ? (
              <Spinner
                animation="border"
                variant="secondary"
                style={{ marginTop: "15px" }}
              />
            ) : (
              searchResult?.slice(0, 4).map((user) => {
                return (
                  <div
                    style={{ marginTop: "15px" }}
                    onClick={() => addGroupUser(user)}
                  >
                    <UserListItem
                      key={user._id}
                      user={user}
                      groupHandler={() => addGroupUser(user)}
                    />
                  </div>
                );
              })
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-header border-0">
          <Button
            style={{
              background: "#d62d3d",
              border: "none",
            }}
            onClick={(user) => leaveGroup(user)}
          >
            Leave Group
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <ToastContainer
        // position="bottom-center"
        position= {windowInnerwidth>500? "bottom-center" : "top-center"}
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
      /> */}
    </div>
  );
};

export default UpdateGroupModal;
